// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

.app-header {
  --nav-bg: #ffffff;
  --nav-text: #0f172a;
  --nav-muted: #475569;
  --nav-accent: #2563eb;
  --nav-accent-ink: #ffffff;
  --nav-border: #e2e8f0;
  --nav-active-bg: #eff6ff;
  --nav-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);
  --nav-height: 64px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20000;
  height: var(--nav-height);
  background: var(--nav-bg);
  color: var(--nav-text);
  border-bottom: 1px solid var(--nav-border);
  box-shadow: var(--nav-shadow);
  box-sizing: border-box;
  overflow: visible;
  transform: translateY(0);
  transition: transform 0.22s ease;
}

.app-header[data-theme="dark"] {
  --nav-bg: #172033;
  --nav-text: #f1f5f9;
  --nav-muted: #cbd5e1;
  --nav-accent: #38bdf8;
  --nav-accent-ink: #082033;
  --nav-border: #334155;
  --nav-active-bg: rgba(56, 189, 248, 0.14);
  --nav-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 10px 28px rgba(0, 0, 0, 0.24);
}

.app-header.is-hidden {
  transform: translateY(-100%);
}

.app-header-spacer {
  height: 64px;
  flex-shrink: 0;
}

.app-header__bar {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 64px;
  padding: 0 20px;
  box-sizing: border-box;
}

.logo-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
}

.company-logo {
  display: block;
  height: 44px;
  width: auto;
  max-height: 44px;
  max-width: 180px;
  margin: 0;
  object-fit: contain;
}

.app-header__menu {
  display: none;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--nav-border);
  border-radius: 10px;
  background: transparent;
  color: var(--nav-text);
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.app-header__menu svg {
  width: 18px;
  height: 18px;
  display: block;
}

.nav-links {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: visible;
}

.nav-links a,
.runtime-menu-button,
.app-header__theme,
.logout-button {
  text-decoration: none;
  color: var(--nav-text);
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.nav-links > a,
.runtime-menu-button,
.app-header__theme,
.logout-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 10px;
  border-radius: 9px;
  box-sizing: border-box;
}

.nav-links > a:hover,
.runtime-menu-button:hover,
.app-header__theme:hover,
.logout-button:hover {
  color: var(--nav-accent);
  background: var(--nav-active-bg);
  text-decoration: none;
}

.nav-links > a.is-active,
.runtime-menu.is-active .runtime-menu-button {
  color: var(--nav-accent);
  background: var(--nav-active-bg);
}

.nav-links a:focus-visible,
.runtime-menu-button:focus-visible,
.app-header__theme:focus-visible,
.logout-button:focus-visible,
.app-header__menu:focus-visible {
  outline: 2px solid var(--nav-accent);
  outline-offset: 2px;
}

.runtime-menu {
  position: relative;
  display: inline-flex;
  align-items: center;
  overflow: visible;
}

.runtime-menu-button {
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
}

.runtime-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  min-width: 220px;
  max-height: min(320px, calc(100vh - 88px));
  overflow-y: auto;
  background: var(--nav-bg);
  border: 1px solid var(--nav-border);
  border-radius: 12px;
  box-shadow: var(--nav-shadow);
  padding: 6px;
  z-index: 30000;
}

.runtime-dropdown-item,
.runtime-empty {
  display: block;
  padding: 9px 10px;
  border-radius: 8px;
  color: var(--nav-text);
  text-decoration: none;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
}

.runtime-dropdown-item:hover,
.runtime-dropdown-item:focus-visible {
  background: var(--nav-active-bg);
  color: var(--nav-accent);
}

.runtime-empty {
  color: var(--nav-muted);
}

.app-header__theme,
.logout-button {
  border: 1px solid var(--nav-border);
  background: transparent;
  cursor: pointer;
  font-family: inherit;
}

.logout-button {
  border-color: var(--nav-accent);
  color: var(--nav-accent);
}

.logout-button:hover {
  background: var(--nav-accent);
  color: var(--nav-accent-ink);
}

@media (prefers-reduced-motion: reduce) {
  .app-header {
    transition: none;
  }
}

@media screen and (max-width: 1199px) {
  .app-header__menu {
    display: inline-flex;
  }

  .nav-links {
    display: none;
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    max-height: calc(100vh - 64px);
    overflow: auto;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    padding: 10px;
    background: var(--nav-bg);
    border-bottom: 1px solid var(--nav-border);
    box-shadow: var(--nav-shadow);
  }

  .nav-links.is-open {
    display: flex;
  }

  .nav-links > a,
  .runtime-menu,
  .runtime-menu-button,
  .app-header__theme,
  .logout-button {
    width: 100%;
    justify-content: flex-start;
  }

  .runtime-menu {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .runtime-dropdown {
    position: static;
    right: auto;
    width: 100%;
    min-width: 0;
    max-height: 220px;
    margin-top: 4px;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,iFAAiF;EACjF,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;EACzC,4EAA4E;AAC9E;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;EAIE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;EAIE,wBAAwB;EACxB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;;;;EAKE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,8BAA8B;IAC9B,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,0CAA0C;IAC1C,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;;;;;IAKE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n}\n\n.app-header {\n  --nav-bg: #ffffff;\n  --nav-text: #0f172a;\n  --nav-muted: #475569;\n  --nav-accent: #2563eb;\n  --nav-accent-ink: #ffffff;\n  --nav-border: #e2e8f0;\n  --nav-active-bg: #eff6ff;\n  --nav-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);\n  --nav-height: 64px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 20000;\n  height: var(--nav-height);\n  background: var(--nav-bg);\n  color: var(--nav-text);\n  border-bottom: 1px solid var(--nav-border);\n  box-shadow: var(--nav-shadow);\n  box-sizing: border-box;\n  overflow: visible;\n  transform: translateY(0);\n  transition: transform 0.22s ease;\n}\n\n.app-header[data-theme=\"dark\"] {\n  --nav-bg: #172033;\n  --nav-text: #f1f5f9;\n  --nav-muted: #cbd5e1;\n  --nav-accent: #38bdf8;\n  --nav-accent-ink: #082033;\n  --nav-border: #334155;\n  --nav-active-bg: rgba(56, 189, 248, 0.14);\n  --nav-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 10px 28px rgba(0, 0, 0, 0.24);\n}\n\n.app-header.is-hidden {\n  transform: translateY(-100%);\n}\n\n.app-header-spacer {\n  height: 64px;\n  flex-shrink: 0;\n}\n\n.app-header__bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  height: 64px;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  text-decoration: none;\n}\n\n.company-logo {\n  display: block;\n  height: 44px;\n  width: auto;\n  max-height: 44px;\n  max-width: 180px;\n  margin: 0;\n  object-fit: contain;\n}\n\n.app-header__menu {\n  display: none;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--nav-border);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--nav-text);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.app-header__menu svg {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: visible;\n}\n\n.nav-links a,\n.runtime-menu-button,\n.app-header__theme,\n.logout-button {\n  text-decoration: none;\n  color: var(--nav-text);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.nav-links > a,\n.runtime-menu-button,\n.app-header__theme,\n.logout-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 10px;\n  border-radius: 9px;\n  box-sizing: border-box;\n}\n\n.nav-links > a:hover,\n.runtime-menu-button:hover,\n.app-header__theme:hover,\n.logout-button:hover {\n  color: var(--nav-accent);\n  background: var(--nav-active-bg);\n  text-decoration: none;\n}\n\n.nav-links > a.is-active,\n.runtime-menu.is-active .runtime-menu-button {\n  color: var(--nav-accent);\n  background: var(--nav-active-bg);\n}\n\n.nav-links a:focus-visible,\n.runtime-menu-button:focus-visible,\n.app-header__theme:focus-visible,\n.logout-button:focus-visible,\n.app-header__menu:focus-visible {\n  outline: 2px solid var(--nav-accent);\n  outline-offset: 2px;\n}\n\n.runtime-menu {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  overflow: visible;\n}\n\n.runtime-menu-button {\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.runtime-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  left: auto;\n  min-width: 220px;\n  max-height: min(320px, calc(100vh - 88px));\n  overflow-y: auto;\n  background: var(--nav-bg);\n  border: 1px solid var(--nav-border);\n  border-radius: 12px;\n  box-shadow: var(--nav-shadow);\n  padding: 6px;\n  z-index: 30000;\n}\n\n.runtime-dropdown-item,\n.runtime-empty {\n  display: block;\n  padding: 9px 10px;\n  border-radius: 8px;\n  color: var(--nav-text);\n  text-decoration: none;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.runtime-dropdown-item:hover,\n.runtime-dropdown-item:focus-visible {\n  background: var(--nav-active-bg);\n  color: var(--nav-accent);\n}\n\n.runtime-empty {\n  color: var(--nav-muted);\n}\n\n.app-header__theme,\n.logout-button {\n  border: 1px solid var(--nav-border);\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.logout-button {\n  border-color: var(--nav-accent);\n  color: var(--nav-accent);\n}\n\n.logout-button:hover {\n  background: var(--nav-accent);\n  color: var(--nav-accent-ink);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .app-header {\n    transition: none;\n  }\n}\n\n@media screen and (max-width: 1199px) {\n  .app-header__menu {\n    display: inline-flex;\n  }\n\n  .nav-links {\n    display: none;\n    position: absolute;\n    top: 64px;\n    left: 0;\n    right: 0;\n    max-height: calc(100vh - 64px);\n    overflow: auto;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 4px;\n    padding: 10px;\n    background: var(--nav-bg);\n    border-bottom: 1px solid var(--nav-border);\n    box-shadow: var(--nav-shadow);\n  }\n\n  .nav-links.is-open {\n    display: flex;\n  }\n\n  .nav-links > a,\n  .runtime-menu,\n  .runtime-menu-button,\n  .app-header__theme,\n  .logout-button {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .runtime-menu {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .runtime-dropdown {\n    position: static;\n    right: auto;\n    width: 100%;\n    min-width: 0;\n    max-height: 220px;\n    margin-top: 4px;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
